import flashMessages from 'common/reducers/flashMessages';
import splitTreatments from 'common/reducers/split';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from './actions';
import {
  getOrderLineItemQuantityDiff,
  savedItemWithSku,
  getShippingCost,
  getLineItemProcessing,
} from './selectors';

import {
  getState as getSideNavState,
  toggleVisibility as toggleSideNavVisibility,
} from 'apps/application/header';

export default function(prevState, action) {
  const state = {
    ...prevState,
    flashMessages: flashMessages(prevState.flashMessages, action),
    splitTreatments: splitTreatments(prevState.splitTreatments, action),
  };

  const lineItemPendingWithOfferingId = offeringId => {
    return state.lineItemsPending.find(item => item.offeringId === offeringId);
  };

  switch (action.type) {
    case actions.SHOW_ADD_TO_CART_MESSAGE:
      return {
        ...state,
        addToCartSuccessQuantity: action.quantity,
      };
    case actions.HIDE_ADD_TO_CART_MESSAGE:
      return {
        ...state,
        addToCartSuccessQuantity: null,
      };
    case actions.CHANGE_VARIANT_QUANTITY:
      const { quantity, variant, offeringId } = action;
      let lineItemsPending = state.lineItemsPending.slice();
      let lineItem = lineItemPendingWithOfferingId(offeringId);
      if (!lineItem) {
        lineItem = {
          sku: variant.sku,
          offeringId,
          quantity,
        };
        lineItemsPending.push(lineItem);
      }

      lineItem.quantity = quantity;
      lineItem.offeringId = offeringId;

      state.lineItemsPending = lineItemsPending;

      return {
        ...state,
        lineItemsPending,
      };

    case actions.SAVE_CART_REQUEST:
      return {
        ...state,
        isSaving: true,
        variantsSaving: action.lineItems,
      };

    case actions.SAVE_CART_SUCCESS:
      const { order } = action;
      const previousOrder = { ...state.currentOrder };
      lineItemsPending = [];

      const newState = {
        ...state,
        currentOrder: order,
        isSaving: false,
        pendingQuantity: 0,
        pendingPrice: 0,
        lineItemsCount: order.total_quantity,
        lineItemsPending,
        lineItemsProcessing: [],
        hasSavedCart: true,
        variantsSaving: [],
      };

      newState.shippingCost = getShippingCost(newState);

      const orderLineItemQuantityDiff = getOrderLineItemQuantityDiff(
        previousOrder,
        order,
        newState
      );

      state.lineItemsPending.forEach(lineItem => {
        const pendingItem = orderLineItemQuantityDiff.find(
          item =>
            item.sku === lineItem.sku && item.offeringId === lineItem.offeringId
        );
        if (!pendingItem || pendingItem.quantityDiff === 0) {
          lineItemsPending.push(lineItem);
        }
      });

      return newState;

    case actions.SAVE_CART_ERROR:
      return {
        ...state,
        pendingQuantity: 0,
        pendingPrice: 0,
        isSaving: false,
        lineItemsPending: [],
        lineItemsProcessing: [],
        variantsSaving: [],
      };

    case actions.TOGGLE_CART_VISIBILITY:
      const { shouldOpen } = action;

      const isOpen = (shouldOpen && state.isOpen) || !state.isOpen;
      const currentOrder = { ...state.currentOrder };

      if (isOpen) {
        state.currentOrderAtCartOpen = currentOrder;
        const sideNavIsOpen = getSideNavState();
        if (sideNavIsOpen) {
          toggleSideNavVisibility();
        }
      } else {
        state.currentOrderAtCartOpen = null;
        currentOrder.line_items = currentOrder.line_items.filter(item => {
          return item.quantity !== 0;
        });
      }

      return {
        ...state,
        currentOrder,
        isOpen,
      };

    case actions.CHANGE_LINE_ITEM_PROCESSING_QUANTITY: {
      const lineItemsProcessing = state.lineItemsProcessing.slice();
      const { lineItem, quantity, offeringId } = action;

      const lineItemExisting = getLineItemProcessing(state, lineItem);
      if (lineItemExisting) {
        lineItemExisting.quantity = quantity;
      } else {
        lineItemsProcessing.push({
          sku: lineItem.sku,
          quantity,
          offeringId,
        });
      }

      return {
        ...state,
        lineItemsProcessing,
      };
    }

    case actions.CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY: {
      return {
        ...state,
        commitmentDetailsIsOpen: action.value,
      };
    }

    case actions.CHANGE_SUBSCRIBING_STATUS: {
      return {
        ...state,
        userIsSubscribing: action.value,
      };
    }

    case actions.SIDEBAR_FOCUS_CHANGED: {
      return {
        ...state,
        sidebarIsFocused: action.isFocused,
      };
    }

    case actions.CHANGE_QUICK_SHOP_SELECTED_VARIANT: {
      const newPendingSku = action.variant.sku;
      const newPendingSkuSavedLineItem = savedItemWithSku(newPendingSku, state);
      const oldPendingLineItem = state.lineItemsPending[0];
      const oldPendingSkuSavedLineItem = oldPendingLineItem
        ? savedItemWithSku(oldPendingLineItem.sku, state)
        : null;

      let newPendingQuantity = oldPendingLineItem
        ? oldPendingLineItem.quantity
        : 0;

      if (oldPendingSkuSavedLineItem) {
        newPendingQuantity -= oldPendingSkuSavedLineItem.quantity;
      }

      if (newPendingSkuSavedLineItem) {
        newPendingQuantity += newPendingSkuSavedLineItem.quantity;
      }

      const newPendingLineItem = {
        sku: newPendingSku,
        quantity: newPendingQuantity,
      };

      return {
        ...state,
        lineItemsPending: [newPendingLineItem],
        selectedQuickShopVariant: action.variant,
      };
    }

    case actions.CHANGE_QUICK_SHOP_MODAL_VISIBILITY: {
      return {
        ...state,
        lineItemsPending: [],
        quickShopIsOpen: action.value,
        quickShopVariants: action.variants,
        taxonName: action.taxonName,
        selectedQuickShopVariant: state.isOpen
          ? state.selectedQuickShopVariant
          : null,
        showExciseTaxDisclaimer: action.showExciseTaxDisclaimer,
      };
    }

    case actions.CHANGE_COMMITMENT_UPSELL_MODAL_VISIBILITY: {
      const { value } = action;
      return {
        ...state,
        commitmentUpsellModalIsOpen: value,
      };
    }

    case actions.REPORT_EVERGREEN_OFFERING: {
      return {
        ...state,
        evergreenOffering: action.offering,
      };
    }

    case actions.CART_LINE_ITEMS_COUNT_LOADED: {
      return {
        ...state,
        lineItemsCount: action.totalItems,
      };
    }

    case actions.CONVERT_ORDER_TO_SUBSCRIPTION:
      return {
        ...state,
        convertingOrderToSubscription: action.order,
      };

    case actions.CONVERT_ORDER_TO_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        convertingOrderToSubscription: null,
      };

    default:
      return state;
  }
}
